export default {"src":"/_next/static/media/nautilus-dark.14038e7b.svg","height":37,"width":160,"blurWidth":0,"blurHeight":0};